import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPendingAction, setFormDirty, triggerUnsavedChangesPrompt } from "../common/actions";
import Portal from "../common/components/Portal";
import ConfirmationModal from "../common/components/ConfirmationModal";
import { useHistory } from "react-router-dom";

const UnsavedChangesCustomPrompt = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { showUnsavedPrompt, isFormDirty, pendingAction } = useSelector(state => state.commonReducer);
    const [nextLocation, setNextLocation] = useState(null);
    const [isNavigating, setIsNavigating] = useState(false);

    useEffect(() => {
        const handleBeforeUnload = event => {
            if (isFormDirty) {
                const message = "You have unsaved changes, do you really want to leave?";
                event.returnValue = message;
                return message;
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [isFormDirty]);

    useEffect(() => {
        const unblock = history.block(location => {
            // Check for suppressPrompt in location state
            if (location?.state?.suppressPrompt) {
                return true; // Allow navigation without prompt
            }
            if (isNavigating) {
                setIsNavigating(false);
                return true;
            }

            if (isFormDirty) {
                setNextLocation(location);
                dispatch(triggerUnsavedChangesPrompt(true));
                return false;
            }
            return true;
        });

        return () => unblock();
    }, [history, isFormDirty, dispatch, isNavigating]);

    const handleConfirmNavigation = () => {
        dispatch(setFormDirty(false));
        dispatch(triggerUnsavedChangesPrompt(false));
        setIsNavigating(true);
        setTimeout(() => {
            if (pendingAction) {
                pendingAction();
                dispatch(setPendingAction(null));
                setIsNavigating(false);
            } else if (nextLocation) {
                history.push(nextLocation.pathname);
                setNextLocation(null);
                setIsNavigating(false);
            }
        }, 500);
    };

    const handleCancelNavigation = () => {
        dispatch(setPendingAction(null));
        dispatch(triggerUnsavedChangesPrompt(false));
        setNextLocation(null);
    };

    if (!showUnsavedPrompt) {
        return null;
    }

    return (
        <Portal
            body={
                <ConfirmationModal
                    type="cancel"
                    heading={"You have unsaved changes!"}
                    message={"This action cannot be reverted, are you sure you want to leave?"}
                    onNo={handleCancelNavigation}
                    onYes={handleConfirmNavigation}
                />
            }
            onCancel={handleCancelNavigation}
        />
    );
};

export default UnsavedChangesCustomPrompt;
